(function () {
  "use strict";

  function isDesktop() {
    return window.matchMedia("(min-width: 750px)").matches;
  }

  function initSubscribeSave(root) {
    if (!root || root.dataset.subscribeSaveInit === "1") return;
    root.dataset.subscribeSaveInit = "1";

    const mqDesktop = window.matchMedia("(min-width: 750px)");
    const finder = root.querySelector("#finder");
    const modalWrap = root.querySelector("[data-freq-modal]");
    const modalOverlay = root.querySelector("[data-freq-modal-overlay]");
    const modalClose = root.querySelector("[data-freq-close]");
    const modalProduct = root.querySelector("[data-modal-product]");
    const modalPrice = root.querySelector("[data-modal-price]");
    const sheetOverlay = root.querySelector("[data-sheet-overlay]");
    const sheetDialog = root.querySelector("[data-sheet-dialog]");
    const sheetProduct = root.querySelector("[data-sheet-product]");
    const sheetPrice = root.querySelector("[data-sheet-price]");
    const stickyBar = root.querySelector("[data-sticky-bar]");
    const toast = root.querySelector("[data-toast]");
    const desktopFreqOptions = root.querySelector("[data-freq-options-desktop]");
    const mobileFreqOptions = root.querySelector("[data-freq-options-mobile]");
    const defaultFreqDesktopHTML = desktopFreqOptions ? desktopFreqOptions.innerHTML : "";
    const defaultFreqMobileHTML = mobileFreqOptions ? mobileFreqOptions.innerHTML : "";
    const saveBadgeFallback = root.dataset.saveBadge || "Save 15%";

    function portalToBody(node) {
      if (node && node.parentElement !== document.body) {
        document.body.appendChild(node);
      }
    }

    portalToBody(modalWrap);
    portalToBody(sheetOverlay);

    let activeVariantId = null;
    let confirmInFlight = false;
    let pickerTriggerEl = null;

    function getPickerDialog() {
      const picker = getActivePickerRoot();
      return picker ? picker.querySelector('[role="dialog"]') : null;
    }

    function syncFreqRadios() {
      freqOptionContainers().forEach(function (container) {
        if (!container.getAttribute("role")) container.setAttribute("role", "radiogroup");
        container.querySelectorAll(".ss-freq-opt").forEach(function (opt) {
          opt.setAttribute("role", "radio");
          const selected = opt.classList.contains("is-selected");
          opt.setAttribute("aria-checked", selected ? "true" : "false");
          opt.setAttribute("tabindex", selected ? "0" : "-1");
        });
      });
    }

    function freqOptionContainers() {
      const nodes = [];
      const desktop =
        desktopFreqOptions ||
        (modalWrap && modalWrap.querySelector("[data-freq-options-desktop]"));
      const mobile =
        mobileFreqOptions ||
        (sheetOverlay && sheetOverlay.querySelector("[data-freq-options-mobile]"));
      if (desktop) nodes.push(desktop);
      if (mobile) nodes.push(mobile);
      return nodes;
    }

    function getFreqOptionsScope() {
      if (mqDesktop.matches) {
        return (
          desktopFreqOptions ||
          (modalWrap && modalWrap.querySelector("[data-freq-options-desktop]"))
        );
      }
      return (
        mobileFreqOptions ||
        (sheetOverlay && sheetOverlay.querySelector("[data-freq-options-mobile]"))
      );
    }

    function getActivePickerRoot() {
      return mqDesktop.matches ? modalWrap : sheetOverlay;
    }

    function getConfirmButton() {
      const picker = getActivePickerRoot();
      if (!picker) return null;
      return picker.querySelector("[data-freq-confirm], [data-sheet-confirm]");
    }

    function getPickerErrorEl() {
      const picker = getActivePickerRoot();
      return picker ? picker.querySelector("[data-ss-freq-error]") : null;
    }

    function showPickerError(message) {
      const err = getPickerErrorEl();
      if (!err) {
        if (message) window.alert(message);
        return;
      }
      if (!message) {
        err.hidden = true;
        err.textContent = "";
        return;
      }
      err.hidden = false;
      err.textContent = message;
    }

    function getSelectedFreqOpt() {
      const scope = getFreqOptionsScope();
      return scope ? scope.querySelector(".ss-freq-opt.is-selected") : null;
    }

    function getSelectedFreqLabel() {
      const sel = getSelectedFreqOpt();
      if (!sel) return "";
      const lab = sel.querySelector(".ss-freq-label, .ss-freq-opt-label");
      return lab ? lab.textContent.trim() : "";
    }

    function setFreqSelection(clicked) {
      if (!clicked) return;
      const planId = clicked.getAttribute("data-selling-plan-id") || "";
      const clickedIndex = Array.prototype.indexOf.call(
        clicked.parentElement ? clicked.parentElement.querySelectorAll(".ss-freq-opt") : [],
        clicked
      );

      freqOptionContainers().forEach(function (container) {
        const opts = container.querySelectorAll(".ss-freq-opt");
        opts.forEach(function (o, index) {
          const match = planId
            ? o.getAttribute("data-selling-plan-id") === planId
            : index === clickedIndex;
          o.classList.toggle("is-selected", match);
          o.setAttribute("aria-checked", match ? "true" : "false");
          o.setAttribute("tabindex", match ? "0" : "-1");
        });
      });

      const price = clicked.getAttribute("data-price") || clicked.dataset.price;
      if (price) {
        const cleanPrice = stripHtml(price);
        if (modalPrice) modalPrice.textContent = cleanPrice;
        if (sheetPrice) sheetPrice.textContent = cleanPrice;
      }
      showPickerError("");
    }

    function planSaveBadge(plan) {
      if (plan && plan.save_percent) return "Save " + plan.save_percent + "%";
      return saveBadgeFallback;
    }

    function buildFreqOption(plan, isSelected, labelClass) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ss-freq-opt" + (isSelected ? " is-selected" : "");
      btn.setAttribute("data-freq-opt", "");
      btn.setAttribute("role", "radio");
      btn.setAttribute("aria-checked", isSelected ? "true" : "false");
      btn.setAttribute("tabindex", isSelected ? "0" : "-1");
      if (plan.id) btn.setAttribute("data-selling-plan-id", String(plan.id));
      if (plan.price) btn.setAttribute("data-price", plan.price);

      const left = document.createElement("span");
      left.className = "ss-freq-opt-left";

      const radio = document.createElement("span");
      radio.className = "ss-freq-radio";
      radio.setAttribute("aria-hidden", "true");

      const label = document.createElement("span");
      label.className = labelClass;
      label.textContent = plan.name || "";

      left.appendChild(radio);
      left.appendChild(label);

      const badge = document.createElement("span");
      badge.className = labelClass === "ss-freq-label" ? "ss-freq-savings" : "ss-freq-save-badge";
      badge.textContent = planSaveBadge(plan);

      btn.appendChild(left);
      btn.appendChild(badge);
      return btn;
    }

    function normalizePlanName(name) {
      return (name || "").trim().toLowerCase().replace(/\s+/g, " ");
    }

    function dedupePlans(plans) {
      if (!Array.isArray(plans)) return [];
      const seenId = new Set();
      const seenName = new Set();
      const unique = [];

      plans.forEach(function (plan) {
        const idKey = plan.id != null ? String(plan.id) : "";
        const nameKey = normalizePlanName(plan.name);
        if (idKey && seenId.has(idKey)) return;
        if (nameKey && seenName.has(nameKey)) return;
        if (idKey) seenId.add(idKey);
        if (nameKey) seenName.add(nameKey);
        unique.push(plan);
      });

      unique.sort(function (a, b) {
        const am = Number(a.months) || 0;
        const bm = Number(b.months) || 0;
        if (am && bm && am !== bm) return am - bm;
        return normalizePlanName(a.name).localeCompare(normalizePlanName(b.name));
      });

      return unique;
    }

    function populateFreqOptions(plans) {
      const uniquePlans = dedupePlans(plans);
      const hasPlans = uniquePlans.length > 0;

      [desktopFreqOptions, mobileFreqOptions].forEach(function (container, index) {
        if (!container) return;
        if (!hasPlans) {
          container.innerHTML = index === 0 ? defaultFreqDesktopHTML : defaultFreqMobileHTML;
          return;
        }
        container.innerHTML = "";
        uniquePlans.forEach(function (plan, i) {
          const labelClass = container === desktopFreqOptions ? "ss-freq-label" : "ss-freq-opt-label";
          container.appendChild(buildFreqOption(plan, i === 0, labelClass));
        });
      });
      syncFreqRadios();
    }

    function getPlansFromCard(card) {
      if (!card) return [];
      const plansEl = card.querySelector(".ss-card-plans");
      if (!plansEl) return [];
      try {
        return JSON.parse(plansEl.textContent);
      } catch (err) {
        return [];
      }
    }

    function parsePlanMonths(plan) {
      const fromData = Number(plan && plan.months) || 0;
      if (fromData > 0) return fromData;

      const name = (plan && plan.name) || "";
      const monthMatch = name.match(/(\d+)\s*month/i);
      if (monthMatch) return Number(monthMatch[1]);
      if (/month/i.test(name)) return 1;

      const weekMatch = name.match(/(\d+)\s*week/i);
      if (weekMatch) return Math.max(1, Math.round((Number(weekMatch[1]) * 7) / 30));

      return 0;
    }

    function buildReplaceEverySummary(plans) {
      const months = dedupePlans(plans)
        .map(parsePlanMonths)
        .filter(function (m) {
          return m > 0;
        });
      if (!months.length) return "";
      const min = Math.min.apply(null, months);
      const max = Math.max.apply(null, months);
      if (min === max) return "Replace every " + min + " months";
      return "Replace every " + min + "\u2013" + max + " months";
    }

    function populateReplaceEveryLabels() {
      root.querySelectorAll(".ss-ac-card").forEach(function (card) {
        const freqEl = card.querySelector(".ss-ac-freq");
        if (!freqEl || freqEl.textContent.trim()) return;
        const summary = buildReplaceEverySummary(getPlansFromCard(card));
        if (summary) freqEl.textContent = summary;
      });
    }

    function stripHtml(text) {
      if (!text) return "";
      const el = document.createElement("div");
      el.innerHTML = text;
      return el.textContent || el.innerText || "";
    }

    function openPicker(productName, price, plans, variantId, triggerEl) {
      pickerTriggerEl = triggerEl || null;
      activeVariantId = variantId ? String(variantId) : null;
      showPickerError("");
      populateFreqOptions(plans);
      const cleanPrice = stripHtml(price);
      if (modalProduct) modalProduct.textContent = productName;
      if (sheetProduct) sheetProduct.textContent = productName;
      if (modalPrice) modalPrice.textContent = cleanPrice;
      if (sheetPrice) sheetPrice.textContent = cleanPrice;

      const firstSelected = getSelectedFreqOpt();
      if (firstSelected && firstSelected.getAttribute("data-price")) {
        const selectedPrice = stripHtml(firstSelected.getAttribute("data-price"));
        if (modalPrice) modalPrice.textContent = selectedPrice;
        if (sheetPrice) sheetPrice.textContent = selectedPrice;
      }

      if (mqDesktop.matches) {
        if (modalWrap) {
          modalWrap.classList.add("is-open");
          modalWrap.setAttribute("aria-hidden", "false");
        }
        document.body.classList.add("ss-freq-modal-open");
        document.body.style.overflow = "hidden";
      } else {
        if (sheetOverlay) {
          sheetOverlay.classList.add("is-open");
          sheetOverlay.setAttribute("aria-hidden", "false");
        }
        document.body.classList.add("ss-freq-modal-open");
        document.body.style.overflow = "hidden";
      }

      const dialog = getPickerDialog();
      if (dialog && typeof trapFocus === "function") {
        const closeBtn = dialog.querySelector("[data-freq-close]");
        const focusTarget = closeBtn || getSelectedFreqOpt() || getConfirmButton();
        trapFocus(dialog, focusTarget || dialog);
      }
    }

    function closePicker() {
      const trigger = pickerTriggerEl;
      if (modalWrap) {
        modalWrap.classList.remove("is-open");
        modalWrap.setAttribute("aria-hidden", "true");
      }
      if (sheetOverlay) {
        sheetOverlay.classList.remove("is-open");
        sheetOverlay.setAttribute("aria-hidden", "true");
      }
      document.body.style.overflow = "";
      document.body.classList.remove("ss-freq-modal-open");
      if (typeof removeTrapFocus === "function") {
        removeTrapFocus();
      }
      populateFreqOptions([]);
      activeVariantId = null;
      showPickerError("");
      pickerTriggerEl = null;
      if (trigger && typeof trigger.focus === "function") {
        trigger.focus();
      }
    }

    function activateCategoryTab(tab) {
      if (!tab || !tab.dataset.cat) return;
      const id = tab.dataset.cat;
      root.querySelectorAll(".ss-cat-tab").forEach(function (b) {
        const on = b === tab;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
        b.setAttribute("tabindex", on ? "0" : "-1");
      });
      root.querySelectorAll(".ss-cat-panel").forEach(function (p) {
        const on = p.id === "cat-" + id;
        p.classList.toggle("is-active", on);
        if (on) p.removeAttribute("hidden");
        else p.setAttribute("hidden", "");
      });
      root.querySelectorAll(".ss-acc-trigger[aria-expanded='true']").forEach(function (tr) {
        tr.setAttribute("aria-expanded", "false");
        const pan = tr.nextElementSibling;
        if (pan) pan.setAttribute("hidden", "");
      });
    }

    function handleFreqRadiogroupKeydown(e) {
      const opt = e.target.closest(".ss-freq-opt");
      if (!opt) return;
      const group = opt.closest('[role="radiogroup"]');
      if (!group) return;
      const opts = Array.prototype.slice.call(group.querySelectorAll(".ss-freq-opt"));
      const idx = opts.indexOf(opt);
      if (idx < 0) return;

      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        setFreqSelection(opt);
        return;
      }

      let next = null;
      if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        e.preventDefault();
        next = opts[(idx + 1) % opts.length];
      } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
        e.preventDefault();
        next = opts[(idx - 1 + opts.length) % opts.length];
      } else if (e.key === "Home") {
        e.preventDefault();
        next = opts[0];
      } else if (e.key === "End") {
        e.preventDefault();
        next = opts[opts.length - 1];
      }

      if (next) {
        opts.forEach(function (o) {
          o.setAttribute("tabindex", o === next ? "0" : "-1");
        });
        next.focus();
        setFreqSelection(next);
      }
    }

    function setConfirmLoading(isLoading) {
      const btn = getConfirmButton();
      if (!btn) return;
      const spinner = btn.querySelector(".loading__spinner");
      if (isLoading) {
        btn.classList.add("loading");
        btn.setAttribute("aria-disabled", "true");
        if (spinner) spinner.classList.remove("hidden");
      } else {
        btn.classList.remove("loading");
        btn.removeAttribute("aria-disabled");
        if (spinner) spinner.classList.add("hidden");
      }
    }

    let onceAddInFlight = false;

    function addVariantToCart(variantId, options) {
      const opts = options || {};
      const sellingPlanId = opts.sellingPlanId || "";
      const activeElement = opts.activeElement || null;
      const onError =
        typeof opts.onError === "function"
          ? opts.onError
          : function (message) {
              if (message) window.alert(message);
            };

      if (!variantId) {
        onError("Product variant is missing.");
        return Promise.resolve(false);
      }

      const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      if (typeof fetchConfig !== "function" || typeof routes === "undefined") {
        onError("Cart is unavailable. Please refresh the page.");
        return Promise.resolve(false);
      }

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData();
      formData.append("id", String(variantId));
      formData.append("quantity", "1");
      if (sellingPlanId) formData.append("selling_plan", sellingPlanId);

      if (cart && typeof cart.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cart
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(",")
        );
        formData.append("sections_url", window.location.pathname);
        if (typeof cart.setActiveElement === "function" && activeElement) {
          cart.setActiveElement(activeElement);
        }
      }

      config.body = formData;

      return fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            onError(response.description || response.message || "Could not add to cart.");
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "subscribe-save",
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            return false;
          }

          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "subscribe-save",
              productVariantId: variantId,
              cartData: response,
            });
          }

          if (cart && typeof cart.renderContents === "function") {
            if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
            cart.renderContents(response);
          } else {
            window.location.href = routes.cart_url;
          }
          return true;
        })
        .catch(function (err) {
          /* eslint no-console: off */
          console.error(err);
          onError("Could not add to cart. Please try again.");
          return false;
        });
    }

    function setOnceButtonLoading(button, isLoading) {
      if (!button) return;
      button.classList.toggle("is-loading", isLoading);
      if (isLoading) button.setAttribute("aria-disabled", "true");
      else button.removeAttribute("aria-disabled");
    }

    function addSubscriptionToCart() {
      const selected = getSelectedFreqOpt();
      const sellingPlanId = selected ? selected.getAttribute("data-selling-plan-id") : "";

      if (!activeVariantId) {
        showPickerError("This product cannot be subscribed. Link a product with selling plans in the theme editor.");
        return Promise.resolve(false);
      }
      if (!sellingPlanId) {
        showPickerError("Please select a delivery frequency.");
        return Promise.resolve(false);
      }

      return addVariantToCart(activeVariantId, {
        sellingPlanId: sellingPlanId,
        activeElement: getConfirmButton() || selected,
        onError: showPickerError,
      });
    }

    function addOneTimeToCart(variantId, trigger) {
      return addVariantToCart(variantId, {
        activeElement: trigger,
        onError: function (message) {
          if (message) window.alert(message);
        },
      });
    }

    function confirmPicker() {
      if (confirmInFlight) return;
      confirmInFlight = true;
      setConfirmLoading(true);

      addSubscriptionToCart()
        .then(function (ok) {
          if (ok) closePicker();
        })
        .finally(function () {
          confirmInFlight = false;
          setConfirmLoading(false);
        });
    }

    root.addEventListener("click", function (e) {
      const t = e.target;
      if (!(t instanceof Element)) return;

      const tab = t.closest(".ss-cat-tab");
      if (tab && tab.dataset.cat) {
        e.preventDefault();
        activateCategoryTab(tab);
        return;
      }

      const accBtn = t.closest("[data-acc-trigger]");
      if (accBtn) {
        e.preventDefault();
        const panel = accBtn.nextElementSibling;
        if (!panel) return;
        const open = accBtn.getAttribute("aria-expanded") === "true";
        const catPanel = accBtn.closest(".ss-cat-panel");
        if (catPanel) {
          catPanel.querySelectorAll(".ss-acc-trigger").forEach(function (tr) {
            tr.setAttribute("aria-expanded", "false");
            const p = tr.nextElementSibling;
            if (p) p.setAttribute("hidden", "");
          });
        }
        if (!open) {
          accBtn.setAttribute("aria-expanded", "true");
          panel.removeAttribute("hidden");
          if (!mqDesktop.matches && panel.scrollIntoView) {
            panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }
        return;
      }

      const openFreq = t.closest("[data-open-freq]");
      if (openFreq) {
        e.preventDefault();
        const card = openFreq.closest(".ss-ac-card");
        const plans = getPlansFromCard(card);
        openPicker(
          openFreq.dataset.productName || "",
          openFreq.dataset.price || "",
          plans,
          openFreq.dataset.variantId || "",
          openFreq
        );
        return;
      }

      const onceBtn = t.closest("[data-add-once]");
      if (onceBtn && !onceBtn.hasAttribute("aria-disabled")) {
        e.preventDefault();
        const variantId = onceBtn.getAttribute("data-variant-id") || onceBtn.dataset.variantId || "";
        if (!variantId || onceAddInFlight) return;
        onceAddInFlight = true;
        setOnceButtonLoading(onceBtn, true);
        addOneTimeToCart(variantId, onceBtn).finally(function () {
          onceAddInFlight = false;
          setOnceButtonLoading(onceBtn, false);
        });
        return;
      }

      const scrollFinder = t.closest("[data-scroll-finder]");
      if (scrollFinder && finder) {
        e.preventDefault();
        finder.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    function handlePickerUiClick(e) {
      const t = e.target;
      if (!(t instanceof Element)) return false;

      const freqOpt = t.closest("[data-freq-opt], .ss-freq-opt");
      if (freqOpt && freqOpt.classList.contains("ss-freq-opt")) {
        e.preventDefault();
        setFreqSelection(freqOpt);
        return true;
      }

      if (t.closest("[data-freq-confirm]") || t.closest("[data-sheet-confirm]")) {
        e.preventDefault();
        confirmPicker();
        return true;
      }

      if (t.closest("[data-freq-close]")) {
        e.preventDefault();
        closePicker();
        return true;
      }

      return false;
    }

    if (modalWrap) {
      modalWrap.addEventListener("keydown", handleFreqRadiogroupKeydown);
      modalWrap.addEventListener("click", function (e) {
        if (handlePickerUiClick(e)) return;
        if (!modalWrap.classList.contains("is-open")) return;
        if (!e.target.closest(".ss-freq-modal")) {
          e.preventDefault();
          closePicker();
        }
      });
    }

    if (sheetOverlay) {
      sheetOverlay.addEventListener("keydown", handleFreqRadiogroupKeydown);
      sheetOverlay.addEventListener("click", function (e) {
        if (handlePickerUiClick(e)) return;
        if (!sheetOverlay.classList.contains("is-open")) return;
        if (!e.target.closest(".ss-sheet")) {
          e.preventDefault();
          closePicker();
        }
      });
    }

    root.addEventListener("keydown", function (e) {
      const tab = e.target.closest(".ss-cat-tab");
      if (!tab) return;
      const tabs = Array.prototype.slice.call(root.querySelectorAll(".ss-cat-tab"));
      const idx = tabs.indexOf(tab);
      if (idx < 0) return;
      let next = null;
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        e.preventDefault();
        const dir = e.key === "ArrowRight" ? 1 : -1;
        next = tabs[(idx + dir + tabs.length) % tabs.length];
      } else if (e.key === "Home") {
        e.preventDefault();
        next = tabs[0];
      } else if (e.key === "End") {
        e.preventDefault();
        next = tabs[tabs.length - 1];
      }
      if (next) {
        activateCategoryTab(next);
        next.focus();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (modalWrap && modalWrap.classList.contains("is-open")) closePicker();
      else if (sheetOverlay && sheetOverlay.classList.contains("is-open")) closePicker();
    });

    if (stickyBar && finder) {
      window.addEventListener(
        "scroll",
        function () {
          if (mqDesktop.matches) return;
          stickyBar.classList.toggle("is-visible", window.scrollY > 200);
        },
        { passive: true }
      );
    }

    mqDesktop.addEventListener("change", function () {
      closePicker();
    });

    freqOptionContainers().forEach(function (container) {
      if (!container.getAttribute("role")) container.setAttribute("role", "radiogroup");
    });
    syncFreqRadios();

    populateReplaceEveryLabels();
  }

  var airRevealObserver = null;
  var airRevealObserved = typeof WeakSet !== "undefined" ? new WeakSet() : null;

  function getAirRevealObserver() {
    if (!("IntersectionObserver" in window)) return null;
    if (!airRevealObserver) {
      airRevealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add("is-visible");
          });
        },
        { threshold: 0.08 }
      );
    }
    return airRevealObserver;
  }

  function initAirReveal(container) {
    var obs = getAirRevealObserver();
    if (!obs) return;
    var root = container || document;
    root.querySelectorAll(".air-reveal").forEach(function (el) {
      if (airRevealObserved) {
        if (airRevealObserved.has(el)) return;
        airRevealObserved.add(el);
      }
      obs.observe(el);
    });
  }

  function initSubscribeSaveFaqDelegation() {
    if (document.body.dataset.ssFaqDelegation === "1") return;
    document.body.dataset.ssFaqDelegation = "1";
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var faqBtn = t.closest("[data-faq-q]");
      if (!faqBtn || !faqBtn.closest("[data-ss-faq]")) return;
      e.preventDefault();
      var faqRoot = faqBtn.closest("[data-ss-faq]");
      if (!faqRoot) return;
      var ans = faqBtn.nextElementSibling;
      var open = faqBtn.getAttribute("aria-expanded") === "true";
      faqRoot.querySelectorAll("[data-faq-q]").forEach(function (q) {
        q.setAttribute("aria-expanded", "false");
        var a = q.nextElementSibling;
        if (a) a.setAttribute("hidden", "");
      });
      if (!open && ans) {
        faqBtn.setAttribute("aria-expanded", "true");
        ans.removeAttribute("hidden");
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-subscribe-save]").forEach(initSubscribeSave);
    initSubscribeSaveFaqDelegation();
    initAirReveal(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (ev) {
    var el = ev.target;
    if (!el || !el.querySelector) return;
    initAirReveal(el);
    var finderRoot = el.querySelector("[data-subscribe-save]");
    if (finderRoot) initSubscribeSave(finderRoot);
  });
})();
